<template>
    <div>
        <div>
            <Loading v-if="serviceLoading" />
            <div v-else>
                <div v-if="replies && replies.length > 0" class="policy-service" :class="[
                    { 'animate__animated animate__zoomOutLeft': replyIsDeleting === reversedReplies[0].id, },
                    { deleting: isReplyDeleted },
                ]">
                    <div class="policy-service__row">
                        <div class="policy-service__data sender-data">
                            <div class="sender">
                                <p class="sender-name">{{ displayUserName(reversedReplies[0].user) }}</p>
                                <p>{{ formatDate(reversedReplies[0].created_at) }}</p>
                            </div>

                            <div class="contact">
                                <a v-if="reversedReplies[0].user?.phone" :href="'tel:' + reversedReplies[0].user.phone">
                                    <div class="icon icon__phone--active"></div>
                                </a>
                                <div v-else class="icon icon__phone"></div>

                                <a v-if="reversedReplies[0].user?.email"
                                    :href="'mailto:' + reversedReplies[0].user.email">
                                    <div class="icon icon__mail--active"></div>
                                </a>
                                <div v-else class="icon icon__mail"></div>
                            </div>
                        </div>
                        <div class="policy-service__data message-data">
                            <p v-if="reversedReplies[0].description">{{ reversedReplies[0].description }}</p>
                            <p v-else>-----</p>
                        </div>
                        <div class="policy-service__data deadline-data medium-data">
                            <p class="deadline">
                                <span v-if="reversedReplies[0].deadline">
                                    {{ formatDate(reversedReplies[0].deadline) }}
                                </span>
                                <span v-else>{{ $t(`dashboard.statistics.${"noDeadline"}`) }}</span>
                            </p>
                            <p>{{ displayUserName(reversedReplies[0].agent) }}</p>
                        </div>

                        <div class="policy-service__data status-data medium-data">
                            <div class="status-indicator" :class="`status-indicator--${reversedReplies[0].status.id}`">
                            </div>

                            <p>{{ reversedReplies[0].status.name }}</p>
                        </div>

                        <div class="policy-service__data tools-data  ">
                            <div class="icon icon__add tool-icon"
                                @click="showAddReplyPendencyModal(policy ? policy.id : null, service.id, agent, service.user);">
                            </div>

                            <div v-if="hasAnyFiles" class="icon icon__pdf--active tool-icon"
                                @click="openPendencyFilesModal()">
                            </div>

                            <div v-else class="icon icon__pdf tool-icon"></div>

                            <div v-if="canEditPendency" class="icon icon__edit tool-icon"
                                @click="showEditReplyModal(reversedReplies[0], service.policy ? service.policy.id : null, service.agent, service.user)">
                            </div>

                            <div v-else class="icon icon__edit tool-icon" style="cursor:no-drop;"></div>

                            <div v-if="canDeletePendency" class="icon icon__delete tool-icon"
                                :class="{ 'icon__delete--active': activeReplyId === reversedReplies[0].id }"
                                tabindex="-1" @focus="activeReplyId = reversedReplies[0].id"
                                @focusout="activeReplyId = null">
                                <transition name="fade">
                                    <div class="delete" v-if="activeReplyId === reversedReplies[0].id">
                                        <div class="delete__text">
                                            {{ $t('pendenciesTable.replyDeleteConfirm') }}
                                        </div>
                                        <div class="delete__buttons">
                                            <div class="button button--confirm"
                                                @click="deletePendencyReply(reversedReplies[0].id)"></div>
                                            <div class="button button--cancel" @click="closeReplyDeletePopup"></div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <div v-else class="icon icon__delete tool-icon" style="cursor:no-drop;"></div>
                        </div>

                        <div class="policy-service__data arrow-data">
                            <div class="icon icon__chevron-down-green" v-if="reversedReplies.length > 0"
                                @click="toggleReplies" :class="showReplies ? 'rotate-chevron' : ''">
                            </div>
                            <div class="icon icon__chevron-down-gray" v-else style="cursor: initial;"></div>
                        </div>
                    </div>
                </div>

                <div v-else class="policy-service" :class="[
                    { 'animate__animated animate__zoomOutLeft': serviceIsDeleting === service.id, },
                    { deleting: isServiceDeleted },
                ]">
                    <div class="policy-service__row">
                        <div class="policy-service__data sender-data">
                            <div class="sender">
                                <p class="sender-name">{{ displayUserName(service.user) }}</p>
                                <p>{{ formatDate(created) }}</p>
                            </div>

                            <div class="contact">
                                <a v-if="service.user?.phone" :href="'tel:' + service.user.phone">
                                    <div class="icon icon__phone--active"></div>
                                </a>
                                <div v-else class="icon icon__phone"></div>

                                <a v-if="service.user?.email" :href="'mailto:' + service.user.email">
                                    <div class="icon icon__mail--active"></div>
                                </a>
                                <div v-else class="icon icon__mail"></div>
                            </div>
                        </div>

                        <div class="policy-service__data message-data">
                            <p v-if="description">{{ description }}</p>
                            <p v-else>-----</p>
                        </div>
                        <div class="policy-service__data deadline-data medium-data">
                            <p class="deadline">
                                <span v-if="deadline">
                                    {{ formatDate(deadline) }}
                                </span>
                                <span v-else>{{ $t(`dashboard.statistics.${"noDeadline"}`) }}</span>
                            </p>
                            <p>{{ agent.first_name }} {{ agent.last_name }}</p>
                        </div>
                        <div class="policy-service__data status-data medium-data">
                            <div class="status-indicator" :class="`status-indicator--${status.id}`"> </div>
                            <p>{{ status.name}}</p>
                        </div>

                        <div class="policy-service__data tools-data  ">
                            <div class="icon icon__add tool-icon"
                                @click="showAddReplyPendencyModal(policy ? policy.id : null, service.id, agent, service.user);">
                            </div>

                            <div v-if="hasAnyFiles" class="icon icon__pdf--active tool-icon"
                                @click="openPendencyFilesModal()">
                            </div>

                            <div v-else class="icon icon__pdf tool-icon"></div>

                            <div class="icon icon__edit tool-icon" @click="showEditPendencyModal(service)"></div>

                            <div class="icon icon__delete tool-icon"
                                :class="{ 'icon__delete--active': showDeletePendency }" tabindex="-1"
                                @focus="showDeletePendency = true" @focusout="showDeletePendency = false" ref="delete">
                                <transition name="fade">
                                    <div class="delete" v-if="showDeletePendency">
                                        <div class="delete__text">
                                            {{ $t('pendenciesTable.pendencyDeleteConfirm') }}
                                        </div>
                                        <div class="delete__buttons">
                                            <div class="button button--confirm" @click="deletePendency()"></div>
                                            <div class="button button--cancel" @click="closeDeletePopup()"></div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>

                        <div class="policy-service__data arrow-data">
                            <div class="icon icon__chevron-down-green" v-if="reversedReplies.length > 0"
                                @click="toggleReplies" :class="showReplies ? 'rotate-chevron' : ''">
                            </div>
                            <div class="icon icon__chevron-down-gray" v-else style="cursor: initial;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showReplies">
            <div v-for="reply in filteredReversedReplies" :key="reply.id" class="policy-service" :class="[
                { 'animate__animated animate__zoomOutLeft': replyIsDeleting === reply.id, },
                { deleting: isReplyDeleted },
            ]">
                <div class="policy-service__row">
                    <div class="policy-service__data sender-data">
                        <div class="sender">
                            <p class="sender-name">{{ displayUserName(reply.user) }}</p>
                            <p>{{ formatDate(reply.created_at) }}</p>
                        </div>

                        <div class="contact">
                            <a v-if="reply.user?.phone" :href="'tel:' + reply.user.phone">
                                <div class="icon icon__phone--active"></div>
                            </a>
                            <div v-else class="icon icon__phone"></div>

                            <a v-if="reply.user?.email" :href="'mailto:' + reply.user.email">
                                <div class="icon icon__mail--active"></div>
                            </a>
                            <div v-else class="icon icon__mail"></div>
                        </div>
                    </div>

                    <div class="policy-service__data message-data">
                        <p v-if="reply.description">{{ reply.description }}</p>
                        <p v-else>-----</p>
                    </div>
                    <div class="policy-service__data deadline-data medium-data">
                        <p class="deadline">
                            <span v-if="reply.deadline">{{ formatDate(reply.deadline) }}</span>
                            <span v-else>{{ $t(`dashboard.statistics.${"noDeadline"}`) }}</span>
                        </p>
                        <p>{{ displayUserName(reply.agent) }}</p>
                    </div>
                    <div class="policy-service__data status-data medium-data">
                        <div class="status-indicator" :class="`status-indicator--${reply.status.id}`"> </div>
                        <p>{{ reply.status.name}}</p>
                    </div>

                    <div class="policy-service__data tools-data  ">
                        <div class="icon  tool-icon"></div>
                        <div class="icon  tool-icon"></div>
                        <div class="icon icon__edit tool-icon"
                            @click="showEditReplyModal(reply, service.policy ? service.policy.id : null, service.agent, service.user)">
                        </div>
                        <div class="icon icon__delete tool-icon"
                            :class="{ 'icon__delete--active': activeReplyId === reply.id }" tabindex="-1"
                            @focus="activeReplyId = reply.id" @focusout="activeReplyId = null">
                            <transition name="fade">
                                <div class="delete" v-if="activeReplyId === reply.id">
                                    <div class="delete__text">
                                        {{ $t('pendenciesTable.replyDeleteConfirm') }}
                                    </div>
                                    <div class="delete__buttons">
                                        <div class="button button--confirm" @click="deletePendencyReply(reply.id)">
                                        </div>
                                        <div class="button button--cancel" @click="closeReplyDeletePopup"></div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <div class="policy-service__data arrow-data"></div>
                </div>
            </div>

            <div class="policy-service" :class="[
                { 'animate__animated animate__zoomOutLeft': serviceIsDeleting === service.id, },
                { deleting: isServiceDeleted },
            ]">
                <div class="policy-service__row">
                    <div class="policy-service__data sender-data">
                        <div class="sender">
                            <p class="sender-name">{{ displayUserName(service.user) }}</p>
                            <p>{{ formatDate(created) }}</p>
                        </div>

                        <div class="contact">
                            <a v-if="service.user?.phone" :href="'tel:' + service.user.phone">
                                <div class="icon icon__phone--active"></div>
                            </a>
                            <div v-else class="icon icon__phone"></div>

                            <a v-if="service.user?.email" :href="'mailto:' + service.user.email">
                                <div class="icon icon__mail--active"></div>
                            </a>
                            <div v-else class="icon icon__mail"></div>
                        </div>
                    </div>

                    <div class="policy-service__data message-data">
                        <p v-if="description">{{ description }}</p>
                        <p v-else>-----</p>
                    </div>
                    <div class="policy-service__data deadline-data medium-data">
                        <p class="deadline">
                            <span v-if="deadline">{{ formatDate(deadline) }}</span>
                            <span v-else>{{ $t(`dashboard.statistics.${"noDeadline"}`) }}</span>
                        </p>
                        <p>{{ agent.first_name }} {{ agent.last_name }}</p>
                    </div>
                    <div class="policy-service__data status-data medium-data">
                        <div class="status-indicator" :class="`status-indicator--1`"> </div>
                        <p>Zu Erledigen</p>
                    </div>

                    <div class="policy-service__data tools-data  ">
                        <div class="icon  tool-icon"></div>
                        <div class="icon  tool-icon"></div>

                        <div class="icon icon__edit tool-icon" @click="showEditPendencyModal(service)"></div>

                        <div class="icon icon__delete tool-icon" :class="{ 'icon__delete--active': showDeletePendency }"
                            tabindex="-1" @focus="showDeletePendency = true" @focusout="showDeletePendency = false"
                            ref="delete">
                            <transition name="fade">
                                <div class="delete" v-if="showDeletePendency">
                                    <div class="delete__text">
                                        {{ $t('pendenciesTable.pendencyDeleteConfirm') }}
                                    </div>
                                    <div class="delete__buttons">
                                        <div class="button button--confirm" @click="deletePendency()"></div>
                                        <div class="button button--cancel" @click="closeDeletePopup()"></div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <div class="policy-service__data arrow-data"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Loading from "@/partials/Loading";
import { extractEntityTeamIds } from "@/helpers/teamAuthorization";

defineOptions({
    name: "PendencyService"
});

const props = defineProps({
    service: { required: true, type: Object },
    replies: { required: true, type: Array },
    policy: { type: Object },
    agent: { required: true, type: Object },
    created: { required: true, type: String },
    description: { type: String },
    deadline: { type: String },
    receiver: { required: true, type: Object },
    status: { required: true, type: Object },
    offer: { type: [Array, Object], required: false },
});

const emit = defineEmits(['toggle-replies']);
const store = useStore();

// State
const showDeletePendency = ref(false);
// const showDeleteReply = ref(false);
const activeReplyId = ref(null);
const showReplies = ref(false);
const serviceLoading = ref(false);
const serviceIsDeleting = ref("");
const replyIsDeleting = ref("");
const isServiceDeleted = ref(false);
const isReplyDeleted = ref(false);

// Template Refs
// Note: Multiple delete elements exist in template, handled via focus/focusout bindings

// Computed
// const policyForms = computed(() => store.getters.policyForms);
// const language = computed(() => store.getters.language);
const loggedUser = computed(() => store.getters.loggedUser);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const costumerId = computed(() => store.getters.customerDetailsId);
const pendencyTargetTeams = computed(() => extractEntityTeamIds(
    props.receiver
      ?? props.policy?.customer
      ?? store.getters.customer
      ?? props.service?.customer
      ?? {}
));
const canEditPendency = computed(() => {
    if (isSuperAdmin.value) return true;
    return pendencyTargetTeams.value.length > 0
        ? store.getters.canPerformActionOnEntity("pendency_edit", pendencyTargetTeams.value)
        : false;
});
const canDeletePendency = computed(() => {
    if (isSuperAdmin.value) return true;
    return pendencyTargetTeams.value.length > 0
        ? store.getters.canPerformActionOnEntity("pendency_delete", pendencyTargetTeams.value)
        : false;
});
const displayUserName = (user) => [user?.first_name, user?.last_name].filter(Boolean).join(" ") || "-";

const reversedReplies = computed(() => [...(props.replies || [])].reverse());
const filteredReversedReplies = computed(() => reversedReplies.value.slice(1));

const hasAnyFiles = computed(() => {
    const serviceHasFiles = props.service.files?.length;
    let offerHasFiles = false;
    if (props.offer) {
        offerHasFiles = Array.isArray(props.offer)
            ? props.offer.some((o) => o?.files?.length)
            : props.offer.files?.length;
    }
    return !!(serviceHasFiles || offerHasFiles);
});

// Methods
const showEditPendencyModal = (service) => {
    store.commit("setShowAddPendencyModal", true);
    store.commit("setIsPendecyEditing", true);
    store.commit("setPendencyEditData", service);
};

const showEditReplyModal = (reply, policyId, agent) => {
    store.commit("setShowAddPendencyModal", true);
    store.commit("setIsReplyEditing", true);
    store.commit("setPendencyForReply", true);
    store.commit("setReplyEditData", { reply, policyId });
    store.commit("setPendencyReplyAgentData", agent);
};

const toggleReplies = () => {
    showReplies.value = !showReplies.value;
    emit('toggle-replies');
};

const showAddReplyPendencyModal = (policyId, serviceId, agent, user) => {
    const isReplying = (loggedUser.value && user && loggedUser.value.id === user.id);
    store.commit("setIsUserReplyingToPendency", isReplying);
    store.commit("setPendencyForReply", true);
    store.commit("setShowAddPendencyModal", true);
    store.commit("setPendencyReplyData", { policyId, serviceId, agent });
};

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
};

const closeDeletePopup = () => {
    showDeletePendency.value = false;
};

const deletePendency = async () => {
  if (!canDeletePendency.value) return;
  
    closeDeletePopup();
    await store.dispatch("deletePendencies", {
        pendencyId: props.service.id,
        customerId: costumerId.value
    });
    isServiceDeleted.value = true;
};

const closeReplyDeletePopup = () => {
    activeReplyId.value = null;
};

const deletePendencyReply = async (id) => {
  if (!canDeletePendency.value) return;
  
    replyIsDeleting.value = id;
    closeReplyDeletePopup();
    await store.dispatch("deleteReplyPendencies", {
        replyId: id,
        customerId: costumerId.value
    });
    isReplyDeleted.value = true;
    showReplies.value = false;
};

const openPendencyFilesModal = () => {
    if (!isSuperAdmin.value && pendencyTargetTeams.value.length === 0) return;
    if (!isSuperAdmin.value && !store.getters.canPerformActionOnEntity("pendency_edit", pendencyTargetTeams.value)) return;

    const files = props.service.files ? [...props.service.files] : [];

    const addOfferFiles = (offer) => {
        if (!offer?.id) return;

        files.push({
            id: `${offer.policy_offer_code}-Offerte_${offer.id}`,
            name: `${offer.policy_offer_code}-Offerte.pdf`,
            file_name: `${offer.policy_offer_code}-Offerte.pdf`,
            created_at: offer.created_at,
            isDownloadable: true,
            offerId: offer.id,
        });

        if (Array.isArray(offer.files)) {
            files.push(...offer.files);
        }
    };

    const offerItems = Array.isArray(props.offer) ? props.offer : (props.offer ? [props.offer] : []);
    offerItems.forEach(addOfferFiles);

    store.commit("setShowFilesEditModal", true);
    store.commit("setFilesToEditId", props.service.id);
    store.commit("setFilesToEdit", files);
    store.commit("setFilesToEditOffers", offerItems);
    store.commit("setFilesEditMode", 'Pendencies');
};
</script>

<style lang="scss" scoped>
.policy-service {
    max-height: initial !important;
    min-height: 80px !important;
    height: auto !important;
}

.delete {
    width: 350px !important;
}

.policy-service__data {
    flex: initial !important;
}

.replies-row {
    margin-top: 14px;
}

.sender-data {
    justify-content: space-between;
}

.sender-data,
.sender,
.contact {

    display: flex;

}

.sender {
    flex-direction: column;
    justify-content: center;
    color: var(--text-9); 
}

.sender-name,
.deadline {
    margin-bottom: 5px;
}

.contact {
    margin-right: 20px;
    gap: 15px;
}

.message-data {
    p {
        padding: 10px;
        background-color: white;
        border-radius: 10px;
        margin: 10px 0;
        margin-left: 0;
        width: 100%;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
}

.deadline-data {
    flex-direction: column;
    color: var(--text-9);
}

.status-indicator {
    width: 16px;
    height: 16px;

    border-radius: 10px;
}

.status-indicator--1 {
    background-color: #ff3333;
}

.status-indicator--2 {
    background-color: #FF9E0F;
}

.status-indicator--3 {
    background-color: #22db8e;
}

.status-data {
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
}

.tools-data {
    justify-content: space-around;
}

.tool-icon {
    border: 1px solid transparent;
    height: 100%;
    width: 25%;
    border-left-color: #7F8FA426;
}

.icon__delete {
    border-right-color: #7F8FA426;
}

.sender-data {
    width: 22%;
}

.message-data {
    width: 35%;
}

.medium-data {
    width: 14%;
    justify-content: center;
    text-align: center;
}

.tools-data {
    width: 12%;
    justify-content: center;
    text-align: center;
}

.arrow-data {
    width: 3%;
    justify-content: center;
}

.rotate-chevron {
    transform: rotate(180deg);
}




[data-theme="dark"] {

    .message-data p {
        background-color: #46505B;
    }
}
</style>
